import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { user, register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.confirm) { setError("Le due password non coincidono"); return; }
    setLoading(true);
    try { await register(form.email, form.password, form.name); }
    catch (err) { setError(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <section className="w-full max-w-sm space-y-6 animate-rise">
        <div className="space-y-2">
          <img src="/organico-logo.svg" alt="Organico" className="h-10 w-10 rounded-lg" />
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Crea il tuo account</h1>
          <p className="text-sm text-slate-600">Ogni attività ha i propri dipendenti, documenti, cedolini e impostazioni.</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div className="space-y-1.5"><Label htmlFor="name">Nome azienda o referente</Label>
            <Input id="name" value={form.name} onChange={set("name")} placeholder="Pizza & Food S.r.l." data-testid="register-name-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required autoComplete="email" value={form.email} onChange={set("email")} data-testid="register-email-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="password">Password (min. 8 caratteri, lettere e numeri)</Label>
            <Input id="password" type="password" required minLength={8} autoComplete="new-password" value={form.password} onChange={set("password")} data-testid="register-password-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="confirm">Ripeti password</Label>
            <Input id="confirm" type="password" required autoComplete="new-password" value={form.confirm} onChange={set("confirm")} data-testid="register-confirm-input" /></div>
          {error && <p className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="register-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full active:scale-[0.98]" data-testid="register-submit-button">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Crea account
          </Button>
          <p className="text-center text-sm text-slate-600">Hai già un account? <Link to="/login" className="font-medium text-slate-900 underline" data-testid="go-to-login-link">Accedi</Link></p>
        </form>
      </section>
    </div>
  );
}
